import { memo, useLayoutEffect, useState } from 'react';

interface ILoaderControllerProps {
    children: JSX.Element
    loader: JSX.Element
}

// function areEqual(prevProps: any, nextProps: any) {
//     return prevProps.children === nextProps.children
// }

const LoaderController = ({ children, loader }: ILoaderControllerProps) => {
    const [isLoading, setIsLoading] = useState(true)

    useLayoutEffect(() => {
        if (document.readyState === 'complete') {
            Promise.all(Array.from(document.images)
                .filter(img => !img.complete)
                .map(img => new Promise(resolve => { img.onload = img.onerror = resolve })))
                .then(() => {
                    console.log('images finished loading')
                    setIsLoading(false)
                });
        } else {
            window.addEventListener('load', () => {
                setIsLoading(false)
            })

            return () => document.removeEventListener('load', () => setIsLoading(false))
        }
    }, [children])

    return (
        <>
            {isLoading && loader}
            {children}
        </>
    );
};

export default LoaderController;